/** 
 * @type {RegionsFilter} 
 */ 
 const filter = { 
with: null, 
orderBy: null, 
ids: null, 
codes: null, 
names: null, 
} 
 /** 
 * @returns {RegionsFilter} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(filter)); 
 } 



// WEBPACK FOOTER //
// ./resources/js/filters/RegionsFilter.js